import React, {useState, useEffect, useCallback} from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { ResponsiveBar } from '@nivo/bar';

import "react-datepicker/dist/react-datepicker.css";

import Loader from '../Common/Loader';

import { reportService } from '../../Services';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

export const Feedings = () => {
    const [species, setSpecies] = useState();
    const [selectedSpecies, setSelectedSpecies] = useState();
    const [speciesList, setSpeciesList] = useState();
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [report, setReport] = useState(false);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const food = {
        0: 'Percentage of population fed',
        1: 'Percentage of food consumed',
        2: 'Pieces of food consumed'
    }

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            display: 'inline-block',
            width: '300px',
            marginRight: '10px'
          }),
        control: (provided, state) => ({
          ...provided,
          height: '42px',
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    const handleReport = async () => {
        if (species && date) {
            setReportLoading(true);
            const res = await reportService.speciesReport({
                species: species.value,
                date: moment(date).format('DD-MM-YYYY')
            });

            if (res) {
                const normalizedData = days.map((day, index) => {
                    const found = res.feedings.find(d => d.DiveDate === index);
                    return { DiveDate: index, PercentageFed: found ? (species.Individual === 2 ? found.PercentageFed/10 : found.PercentageFed) : 0, Aggression: found ? found.Aggression : 0 };
                });

                res.feedings = normalizedData;
                setReport(res);
                setSelectedSpecies(species)
            }
            
            setReportLoading(false);
        }
    }

    const fetchData = useCallback(async () => {
        setLoading(true);

        const res = await reportService.speciesReportInfo();
        setSpeciesList(res.species);

        setLoading(false);
      }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            {loading ? <Loader /> : <>
                <h1 id="report-title">Feeding and Animal Engagement Report</h1>
                <div className="bordered-content">
                    <div className="header">
                        <h4>Report of feeding and animal engagement level observations by week:</h4>
                        <div className="select-year sentence">
                            <Select className={`select`} options={speciesList} onChange={setSpecies} styles={customStyles} value={species} /> <br className="mobile" />
                            the week of <DatePicker name="date" selected={date} onChange={setDate} placeholderText="Select date" className="required" isClearable /><br className="mobile" />
                            <button className="primary" type="button" onClick={handleReport}>{reportLoading ? <Loading className="btn-loader"alt="loader" /> : ''}Generate report</button>
                        </div>
                    </div>
                </div>
                {report ?
                <div className="bordered-content mt-32" style={{minWidth: 0}}>
                    <div className="header">
                        <h4>{species.label}</h4>
                        <p>Weekly breakdown from {report.weekStart} through {report.weekEnd}</p>
                    </div>
                    <div style={{ height: 450 }} className="chart">
                        <ResponsiveBar
                            data={report.feedings}
                            keys={['PercentageFed']}
                            indexBy="DiveDate"
                            margin={{ top: 10, right: 20, bottom: 60, left: 50 }}
                            minValue={0}
                            maxValue={selectedSpecies.Individual === 2 ? 10 : 100}
                            valueScale={{ type: 'linear', min: 0, max: selectedSpecies.Individual === 2 ? 10 : 100 }}
                            colors={['#4176C6']}
                            borderRadius={4}
                            axisBottom={{
                            tickValues: [0, 1, 2, 3, 4, 5, 6],
                            format: (value) => days[value],
                            legend: food[selectedSpecies.Individual],
                            legendPosition: 'middle',
                            legendOffset: 40,
                            }}
                            axisLeft={{
                                tickValues: selectedSpecies.Individual === 2 ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
                            }}
                            gridYValues={selectedSpecies.Individual === 2 ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] : [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                            tooltip={({ id, value, indexValue }) => (
                            <div style={{
                                background: '#fff',
                                padding: '6px 10px',
                                border: '1px solid #ccc',
                                borderRadius: 4,
                                fontSize: 12,
                            }}>
                                <strong>{food[selectedSpecies.Individual]}</strong>: {value}
                            </div>
                            )}
                        />
                    </div>

                    <div style={{ height: 450 }} className="chart">
                        <ResponsiveBar
                            data={report.feedings}
                            keys={['Aggression']}
                            indexBy="DiveDate"
                            margin={{ top: 10, right: 20, bottom: 60, left: 50 }}
                            minValue={0}
                            maxValue={10}
                            valueScale={{ type: 'linear', min: 0, max: 5 }}
                            colors={['#4176C6']}
                            axisBottom={{
                            tickValues: [0, 1, 2, 3, 4, 5, 6],
                            format: (value) => days[value],
                            legend: 'Animal Engagement',
                            legendPosition: 'middle',
                            legendOffset: 40,
                            }}
                            axisLeft={{
                            tickValues: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
                            }}
                            gridYValues={[0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]}
                            tooltip={({ value }) => (
                            <div style={{
                                background: '#fff',
                                padding: '6px 10px',
                                border: '1px solid #ccc',
                                borderRadius: 4,
                                fontSize: 12,
                            }}>
                                <strong>Engagement</strong>: {value}
                            </div>
                            )}
                        />
                    </div>
                </div> : ''}
            </>}
        </>
    );
};

export default Feedings;